
var initLogoDropzone = function () {
  var $el = $('#js-accomplishment-img-dz');
  if (!$el[0].dropzone) {
    var $logoPath = $('#js-accomplishment-logo-path', $el.parent());
    var $removeLogo = $('#js-accomplishment-remove-logo', $el.parent());
    var $logoUrl = $('#js-accomplishment-logo-url', $el.parent());
    var institutionDZ;

    var fileObj = {
      path: $logoPath.val()
    };

    $el.addClass('dz-unit');


    var message = JST['templates/dropzone-standard-message']({
      title: Kadenze.I18n.t('drop_file_editor.add_logo'),
      optional: Kadenze.I18n.t('drop_file_editor.optional_accomplishment'),
      browse_files: Kadenze.I18n.t('drop_file_editor.browse_files'),
      or: Kadenze.I18n.t('dict.or'),
    });
    message = Kadenze.I18n.tt(message, 'en');

    var uploadURL = Kadenze.Routes.temp_image_upload_path();

    var callbacks = {
      thumbnail: function (file, data) {
      },
      sending: function (file, xhr, formData) {
      },
      success: function (file, response) {
        if (response.path.match(/^https?/)) {
          $logoUrl.val(response.path);
        }
        else {
          $logoPath.val(response.path);
        }
        $removeLogo.val('');
      },
      error: function (file, errorMessage) {
      },
      complete: function (file) {
      },
      addedfile: function (file) {
      },
      removedfile: function (file) {
        $logoPath.val('');
        $removeLogo.val('true');
      }
    };

    var opts = {acceptedFiles: '.svg'};

    institutionDZ = new Kadenze.ImageDropZone($el, message, uploadURL, callbacks, fileObj, opts);
  }
};
export default {
  init : function(element) {
    initLogoDropzone();
    Kadenze.WebApp.initQuillEditors();
  }
};

